import dayjs from "dayjs";

/** توحيد تحليل التواريخ في نافذة تقديم الإجازة (كما في attendance-table) */
export function parseVacationDateValue(dateValue) {
  if (!dateValue) {
    return null;
  }
  let date = dayjs(dateValue, "YYYY-MM-DD HH:mm:ss", true);
  if (!date.isValid()) {
    date = dayjs(dateValue, "YYYY-MM-DD HH:mm", true);
  }
  if (!date.isValid()) {
    date = dayjs(dateValue, "YYYY-MM-DD", true);
  }
  if (!date.isValid()) {
    date = dayjs(dateValue);
  }
  return date.isValid() ? date : null;
}
